export interface ToniAIMapping {
  links: Record<string, string>;
  images: Record<string, string>;
  [key: string]: string | Record<string, string>;
}

export interface ToniAIEmailRequest {
  question: string;
  thread_id: string;
  email_title: string;
  email_body: string;
}

export interface ToniAIEmailResponse {
  thread_id: string;
  chunk: string;
  error: boolean;
  error_message: string;
  is_complete: boolean;
  assembled_result: ToniAIEmailResponseAssembledResult;
  mapping: ToniAIMapping;
}

export interface ToniAIEmailResponseAssembledResult {
  response: string;
  proposed_subject: string;
  subject_should_change: boolean;
  mapping: ToniAIMapping;
}

export enum ToniAIMessageType {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}
export interface ToniAIMessageItem {
  type: ToniAIMessageType;
  time: Date;
  incoming?: ToniAIEmailResponse;
  outgoing?: ToniAIEmailRequest;
}
